import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime, IUserFormParameters } from "../../FormRuntime";

import { FileUploadFormControl } from "../Web/FileUploadFormControl";

import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StateManager } from "../../../rule-engine-core/Common/StateManager";
import { XStackContainer } from "../../Containers";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";

// todo: fix. this is the old template.  it should NOT require to listen to the data outside of the form to work.  FIX!
// const Template: StoryBook<IUserFormParameters> = (args) => (
//
// );

function getUI(): IUserFormParameters {
    let ui = new FormConfiguration();
    let container = new XStackContainer();

    let uploadField = new FileUploadFormControl();
    uploadField.valueName = "upload";
    uploadField.label = "File Upload";

    container.add(uploadField);

    ui.add(container);

    const data = new ExecutionData();

    const result = {
        form: ui,
        onFormDataChange: (_: ExecutionData) => {
            StateManager.propertyChanged(result, "formData");
        },
        formData: data,
    };

    return result;
}

export const FileUploadStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).showFileName = false;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "Without File Name",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).showFileName = true;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "With File Name",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).showFileSize = false;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "Without File Size",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).showFileSize = true;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "With File Size",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).showPreview = false;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "Without Preview",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).showPreview = true;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "With Preview",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).filesLimit = 1;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "Single File",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            (ui.form.getAllControls()[0] as FileUploadFormControl).filesLimit = 3;
            return (
                <ObserveState
                    listenTo={ui}
                    properties={["formData"]}
                    control={() => <FormRuntime {...ui} />}
                />
            );
        },

        "Form Builder",
        "Controls",
        "File Upload",
        "Multiple Files",
    ),
];
